import { jsx as a } from "react/jsx-runtime";
import { ModalHeader as d } from "@chakra-ui/react";
function p({ children: r, sticky: o = !1, ...e }) {
  return /* @__PURE__ */ a(d, { position: o ? "sticky" : void 0, top: o ? 0 : void 0, ...e, children: r });
}
export {
  p as ModalHeader
};
